<template>
    <b-nav-item-dropdown class="user-profile text-center" right >
        
   <!--     <template #button-content="{ expanded }">
            <span class="pdd-right-10">{{user}}</span>
                    <i :class="expanded ? 'ti-angle-up' :'ti-angle-down '" ></i>
                </template>-->
        <!-- Using button-content slot -->
        <template slot="button-content" >
            <div class="m-auto">
                <span class="pdd-right-10">{{user}}</span>
                <i class="ti-more-alt" ></i>
            </div>
            
        </template>

        <b-dropdown-item :to="'/profile'">
            <i class="ti-user pdd-right-10"></i>
            <span>Profil</span>
        </b-dropdown-item>
        <b-dropdown-item @click="$refs.structure_popup.show()" >
            <i class="ti-reload pdd-right-10"></i>
            <span>Changer de Structure/Rôle</span>
        </b-dropdown-item>
        <b-dropdown-item :to="'/logout'">
            <i class="ti-power-off pdd-right-10"></i>
            <span>Se déconnecter</span>
        </b-dropdown-item>
                        <!-- ##################################################################################################################################################################### --> 
            
            <!-- ##################################################################################################################################################################### -->     
            <b-modal ref="structure_popup" hide-footer hide-header centered no-close-on-backdrop>
                    <Choisir-Structure 
                        :structures="structuresDistinct"
                        :email="email"
                        :token="token"
                        @Choisir-Structure-done= "Choisir_Structure_close"
                        @Choisir-Structure-Cancel="$refs.structure_popup.hide()">
                    </Choisir-Structure>
            </b-modal> 
            <!-- ##################################################################################################################################################################### --> 
    </b-nav-item-dropdown>

</template>

<script>
    
    import api from "../../config/_api";
    
    import { mapGetters } from 'vuex';
    import ChoisirStructure from "../../components/Choisir_Structure.vue";

    export default {
        name: "header-user-profile",
        components : {
            'Choisir-Structure': ChoisirStructure},
            data (){
            return{
                error : false,
                expanded : false,
                token: "",
                email: ""
            }
        },
        computed:{
            
            user(){
                if(!this.$store.getters.getProfile.id) return "";
                
                var fullname=this.$store.getters.getProfile.title===null? "" : this.$store.getters.getProfile.title+" ";
                fullname+=this.$store.getters.getProfile.firstname===null? "" : this.$store.getters.getProfile.firstname+" ";
                fullname+=this.$store.getters.getProfile.lastname===null? "" :this.$store.getters.getProfile.lastname ;

                return fullname;
            },
            ...mapGetters({
               structuresDistinct: 'adherents/structuresDistinct',
            }),
        },
         mounted(){
            this.$store.dispatch('adherents/getStructuresDistinct');
            this.token = this.$store.getters.getProfile.api_token;
            this.email = this.$store.getters.getProfile.email;
        },
        methods :{
             Choisir_Structure_close(struct){
              this.$refs.structure_popup.hide();
                if(struct.id==this.$store.getters.structure_id){
                    this.error=false;
                    this.$emit('Choisir-Structure-done',struct.name);
                    this.$router.push({path:'/dashboard'});
                    //window.location.reload();
                }
            },
        }
    }
</script>

<style scoped>
    .header .header-container .nav-left .user-profile, .header .header-container .nav-right .user-profile {
        border-right: 0px solid transparent;
    }
    .width {
    width : 500px
}
</style>